import React from "react";
import { Topbar } from "@components";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import styled from "styled-components";
import {
	AppleFilled,
	FacebookFilled,
	PlayStoreFilled,
	ViberFilled,
	YoutubeFilled,
	ApkFilled,
	TelegramFilled,
} from "@assets";
import { Space } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const RootContainer = styled.div`
	min-height: calc(100vh - 70px);
	text-align: center;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	align-items: center;

	svg {
		cursor: pointer;
	}
`;

const Title = styled.div`
	margin-bottom: 15px;

	color: #340067;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 1.5;
`;

const SocialWrapper = styled(Space)`
	gap: 15px !important;

	svg {
		width: 53px;
		height: auto;
	}
`;

const DownloadWrapper = styled(Space).attrs({
	direction: "vertical",
})`
	gap: 15px !important;
`;

const Wrapper = styled.div`
width: 100%;
padding: 21px 0;
background-color: #F8EEFF;
margin-bottom: 12px;
`;

const AppDownload = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { social_links } = useSelector((state) => state.app.settings);

	const goBack = () => {
		navigate(`/${PUBLIC_ROUTE.HOME}`);
	};

	const Link = ({ url, children }) => (
		<a href={url} target="_blank" rel="noreferrer noopen">
			{children}
		</a>
	);

	return (
		<>
			<Topbar title={t("home.appDownloadTitle")} goBack={goBack} />
			<RootContainer>
				<Wrapper>
					<Title>{t("home.appDownloadSubTitle1")}</Title>
					<SocialWrapper>
						<Link url={social_links?.fb_link}>
							<FacebookFilled />
						</Link>
						<Link url={social_links?.viber_link}>
							<ViberFilled />
						</Link>
						<Link url={social_links?.telegram_link}>
							<TelegramFilled />
						</Link>
						<Link url={social_links?.youtube_link}>
							<YoutubeFilled />
						</Link>
					</SocialWrapper>
				</Wrapper>

				<Wrapper>
					<Title>{t("home.appDownloadSubTitle2")}</Title>
					<DownloadWrapper>
						<Link url={social_links?.app_store_link}>
							<AppleFilled />
						</Link>
						<Link url={social_links?.play_store_link}>
							<PlayStoreFilled />
						</Link>
						<Link url={social_links?.download_link}>
							<ApkFilled />
						</Link>
					</DownloadWrapper>
				</Wrapper>
			</RootContainer>
		</>
	);
};

export default AppDownload;
